import { render, staticRenderFns } from "./AddressForm1.vue?vue&type=template&id=abccc1be&scoped=true"
import script from "./AddressForm1.ts?vue&type=script&lang=ts&external"
export * from "./AddressForm1.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abccc1be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abccc1be')) {
      api.createRecord('abccc1be', component.options)
    } else {
      api.reload('abccc1be', component.options)
    }
    module.hot.accept("./AddressForm1.vue?vue&type=template&id=abccc1be&scoped=true", function () {
      api.rerender('abccc1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P42/AddressForm1/AddressForm1.vue"
export default component.exports